import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Reviens instantanément en haut à chaque changement de route
    window.scrollTo(0, 0);

    // 💡 Option alternative : Si vous voulez un effet fluide, remplacez la ligne du dessus par :
    // window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);

  return null;
};

export default ScrollToTop;